import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
})
export class MenuComponent implements OnInit {
  @Output() clickEvent: EventEmitter<any> = new EventEmitter();
  menuItems = [
    {
      title: 'Home',
      routerLink: '/',
    },
    {
      title: 'Projects',
      url: 'https://archive.mvrdv.nl',
    },
    {
      title: 'Support',
      routerLink: '/support',
    },
    {
      title: 'Employees',
      routerLink: '/employees',
    },
    {
      title: 'Channels',
      routerLink: '/channels',
    },
    {
      title: 'Phone list',
      routerLink: '/phone-list',
    },
  ];

  menuAppItems = [
    {
      title: 'ionBIZ',
      url: '//mvrdv.ionbiz.com',
      icon: 'icon-ionbiz',
    },
  ];

  constructor() {}

  ngOnInit() {}

  clickItem() {
    setTimeout(() => {
      this.clickEvent.emit(true);
    }, 100);
  }
}
